import { render, staticRenderFns } from "./Profesores.vue?vue&type=template&id=0169a3db&scoped=true"
import script from "./Profesores.vue?vue&type=script&lang=js"
export * from "./Profesores.vue?vue&type=script&lang=js"
import style0 from "./Profesores.vue?vue&type=style&index=0&id=0169a3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169a3db",
  null
  
)

export default component.exports